import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import InOutComp from "./InOutComp"
import TextField from "@material-ui/core/TextField";

import { compareAsc, format } from 'date-fns'
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { Link, json } from 'react-router-dom';
import { attendenace_action, get_holidays, get_punch_in_time, get_Punch_Time_In_Month, get_weekly_punch_in_time } from '../../Redux/Actions/attendance_action';
const date = new Date();
// let date_formate = format(date, 'yyyy-MM-dd')
var current_date_day = moment().format('D')



let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
const user_login_id = localStorage.getItem('userId')
function UserAttendanceCom() {


    // const userId = localStorage.getItem('userId'); 
    const [get_date, setGet_date] = useState(format(date, 'yyyy-MM-dd'));
    const [user, setUser] = useState(localStorage.getItem('userId'))






    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const [todaydate, setTodaydate] = useState('');
    const [daysinmonth, setDaysinmonth] = useState({})
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [completeatt, setCompleteatt] = useState([]);
    const [attendance, setAttendance] = useState([]);
    const [timesheetrequest, setTimesheetrequest] = useState(false);



    // Time sheet request state
    const [requesttype, setRequesttype] = useState(1);
    const [regularizedate, setRegularizedate] = useState();
    const [workstatus, setWorkstatus] = useState();
    const [intime, setIntime] = useState("")
    const [outtime, setOuttime] = useState("")
    const [reason, setReason] = useState()
    const [msg, setMsg] = useState('');
    const [err, setErr] = useState('');
    const [savebtn, setSavebtn] = useState(true);
    const [user_attendance_id, setUser_attendance_id] = useState('')

    const [fromdate, setFromdate] = useState()
    const [todate, setTodate] = useState()
    const [leave_type, setLeave_type] = useState('0')
    const [leave_count, setLeave_count] = useState(null)
    const [today_workhr, setToday_workhr] = useState(0);
    const [week_workhr, setWeek_workhr] = useState();
    const [month_workhr, setMonth_workhr] = useState();
    //redux


    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const user_permission = get_oermission_data.login_Permission.permissions;


    const attend_data = useSelector((state) => state.attendenace.data.attendenace_arr);
    const in_out = useSelector((state) => state.attendenace.data.in_out);

    const office_hilidays = useSelector((state) => state.attendenace.data.holiday_arr);
    // console.log('office_hilidays office_hilidays')
    // console.log(office_hilidays)
    // console.log('office_hilidays office_hilidays')
    // const monthSummary = useSelector((state) => state.attendenace.data.monthSummary);

    const attend_data1 = useSelector((state) => state);
    console.log('attend_data1==========')
    console.log(get_oermission_data.attendenace.company_holiday)
    console.log('attend_data1========')

    // console.log('get_oermission_data')
    // console.log(get_oermission_data2?.attendenace?.In_time?.DiffAB)
    // setTimeout(()=>{
    //     const get_oermission_data2 = useSelector((state) => state);
    // },5000)

    // useEffect(()=>{ 
    //     const get_oermission_data2 = useSelector((state) => state);
    // },[])
    //const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions

    const [currenttime, setCurrenttime] = useState(moment().format('LT'))
    const [currMonth_in_Number, setCurrMonth_in_Number] = useState('');
    useEffect(() => {
        const startOfMonth = moment().format('DD MMMM YYYY');
        setTodaydate(startOfMonth)
        setCurrMonth_in_Number(moment().format('M'))
        var currYearName = moment().format('Y');
        setYear(currYearName)

        setMonth(moment().format('MMM'))
    }, []);

    const currentTime = moment().format('HH:mm:ss a');
    useEffect(() => {
        const userId = localStorage.getItem('userId');
        dispatch(get_punch_in_time(localStorage.getItem('userId')));
    }, [currentTime])

    var getDaysArray = function (year, month) {
        var monthIndex = month - 1; // 0..11 instead of 1..12
        var names = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
        var date = new Date(year, monthIndex, 1);
        var result = {};
        while (date.getMonth() == monthIndex) {
            //result.push(date.getDate() + '-' + names[date.getDay()]);

            result[date.getDate()] = names[date.getDay()];
            date.setDate(date.getDate() + 1);
        }
        return result;
    }


    const dispatch = useDispatch()

    useEffect(() => {
        let number_of_days = getDaysArray(2023, currMonth_in_Number)
        setDaysinmonth(number_of_days)
        const lend_rates_arr = Object.keys(daysinmonth);
        setGet_date(year + '-' + currMonth_in_Number + '-01')
        setMonth(moment(currMonth_in_Number, 'M').format('MMM'))

        const state = {
            emp_id: user,
            date: year + '-' + currMonth_in_Number + '-01',
        }
        dispatch(attendenace_action(state))
    }, [user, year, currMonth_in_Number]);
    const userId = localStorage.getItem('userId');
    useEffect(() => {
        dispatch(get_Punch_Time_In_Month(userId))
    }, [])

    function refreshClock() {
        setCurrenttime(moment().format('LT'))
    }
    useEffect(() => {
        const timerId = setInterval(refreshClock, 10000);

    }, []);
    const attendanceTime = [];

    function calculateHourse(timeIn, timeOut) {
        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');
        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes % 60;
        var minutformat = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
        var totalHoursformat = parseInt(totalHours) < 10 ? '0' + totalHours : totalHours;
        return (totalHoursformat + " : " + minutformat);
    }
    function calculateHourseInMinutes(timeIn, timeOut) {
        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');
        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes % 60;
        return ((totalHours * 60) + clearMinutes);
    }


    const attendance_view = (srt_time, end_time, office_holiday, day, key) => {
        if (office_holiday != undefined) {
            return <span className="holiday"></span>
        }
        if ((srt_time != undefined) && (end_time != undefined)) {
            var minuts = calculateHourseInMinutes(srt_time, end_time)
            return minuts > 420 ? <span className="present"></span> : minuts > 240 ? <span className="latein"></span> : <span className="absent"></span>;
            // return minuts;
        }
        if ((srt_time == undefined) && (end_time == undefined) && day != 'sun' && day != 'sat' && (key < parseInt(current_date_day))) {
            return <span className="absent"></span>;
        }
        if ((srt_time == undefined) && (end_time == undefined) && (day == 'sun' || day == 'sat')) {
            return <span className="weeklyoff"></span>;
        }
        if ((srt_time != undefined) && (end_time == undefined) && current_date_day != key) {
            return <span className="absent"></span>;
        }
        else {
            return '';
        }
    }





    var i = 0

    const handleClose = () => {
        setTimesheetrequest(false)
    }
    const handleRegularize = (regdate) => {
        setRegularizedate(moment(regdate).format("YYYY-MM-DD"))
        getUserTodaysAttendance(moment(regdate).format("YYYY-MM-DD"))

    }
    const getUserTodaysAttendance = (regdate) => {
        const response = fetch(SERVER_URL + `api/attendance/myself-attendance-list`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: user_login_id,
                    FindMonth: regdate
                }),
            }).then(res => res.json())
            .then(data => {
                setIntime('')
                setTimeout('')
                setUser_attendance_id('')
                if (data.data.start_time != null || data.data.start_time != undefined) {
                    setUser_attendance_id(data.data.id)
                }
                if (data.data.start_time != null || data.data.start_time != undefined) {
                    setIntime(moment(data.data.start_time, ["HH:mm"]).format("hh:mm"))
                }
                if (data.data.end_time != undefined && data.data.end_time != null) {
                    setOuttime(data.data.end_time != '00:00:00' ? moment(data.data.end_time, ["HH:mm"]).format("hh:mm") : '')
                }
            })
    }
    const handleSubmit = () => {

        if (requesttype == 1) {
            const userId = localStorage.getItem('userId');
            const response = fetch(SERVER_URL + `api/leave/apply-leave`,
                {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: userId,
                        requestType: 1,
                        formDate: fromdate,
                        toDate: todate,
                        leaveType: leave_type,
                        workType: '',
                        description: reason
                    }),
                }).then(res => res.json())
                .then(data => {
                    if (data.status == true) {
                        setMsg('Leave successfully added')
                        setErr('green')
                        setTimeout(function () {
                            handleClose()
                        }, 1000);
                    }
                })
        } else {
            setSavebtn(false)
            const user_login_id = localStorage.getItem('userId')
            const response = fetch(SERVER_URL + `api/attendance/time-sheet-request`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: user_login_id,
                        attId: user_attendance_id,
                        requestDate: regularizedate,
                        requestType: requesttype,
                        requestWorkType: workstatus,
                        startTime: intime,
                        endTime: outtime,
                        requestReason: reason
                    }),
                }).then(res => res.json())
                .then(data => {
                    if (data.status == true) {
                        setErr('green')
                        setMsg('Your time sheet attendance request, Add Successfully')
                        setTimeout(function () {
                            setSavebtn(true)
                            handleClose()
                        }, 1000);

                    } else {
                        setErr('red')
                        setMsg('Something Went Wrong')
                    }
                })
        }

    }
    useEffect(() => {
        Object?.keys(daysinmonth).map(key => {
            if (attend_data[key]?.start_time == '00:00:00' && attend_data[key]?.end_time == '00:00:00' && attend_data[key]?.status == 0) {
                i = i + 1
            }
        })
        setLeave_count(i)
    }, [office_hilidays])
    const [user_filetr, setUser_filter] = useState([])
    useEffect(() => {
        get_emp_list_for_filter()
    }, [])
    const get_emp_list_for_filter = async () => {
        const response = await fetch(SERVER_URL + `api/employee/getEmployeeslist/user_filter`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setUser_filter(data?.data)
                }
            });
    }
    // useEffect(() => {
    //     const user_login_id = localStorage.getItem('userId')
    //     const response = fetch(SERVER_URL + `api/attendance/get-attendence-state?id=${user_login_id}`,
    //         {
    //             method: 'GET',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json',
    //                 'authorization': `bearer ${token.value}`
    //             },
    //         })
    //         .then(res => res.json())
    //         .then(data => { 
    //             if (data.status == true) {
    //                 // console.log(data.data)
    //                 const { day_spend_hr, week_spend_hr, month_spend_hr } = data.data

    //                 // setToday_workhr(day_spend_hr)
    //                 setWeek_workhr(week_spend_hr)
    //                 setMonth_workhr(month_spend_hr)


    //             }
    //         });
    // }, [])

    var systemrole = localStorage.getItem("systemRole");

    // const [todaysHRS, setTodaysHRS] = useState('');
    // useEffect(() => {

    //     setTodaysHRS(att_hrs)
    // }, [])



    // function getWeekOfMonth(input = moment()) {
    //     let dayOfInput = input.clone().day(); // Saunday is 0 and Saturday is 6
    //     let diffToNextWeek = 7 - dayOfInput;
    //     let nextWeekStartDate = input.date() + diffToNextWeek;
    //     return Math.ceil((nextWeekStartDate) / 7);
    // }
    const [weekOff, setWeekOff] = useState('4')
   
    useEffect(() => {
        dispatch(get_weekly_punch_in_time(userId))
    }, [])
    useEffect(() => {
        const get_current_month = currMonth_in_Number ? currMonth_in_Number : moment().format('M')
        const get_current_year = year ? year : moment().format('Y')
        dispatch(get_holidays(get_current_month, year));
       const  weekOfCurrentMonth = (moment().week() - (moment().month()*1));
    }, [currMonth_in_Number, year])
    return (

        <div className="container-fluid">
            <Modal show={timesheetrequest} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" onClick={handleClose} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Time Sheet Request</div>
                    <form>
                        <div className="mb-2">
                            <label className="col-form-label">Select Type :</label>
                            <select value={requesttype} className="form-select" onChange={(e) => setRequesttype(e.target.value)} id="leavetype">
                                <option value="1">Leave</option>
                                <option value="2">Regularise Time Sheet</option>
                            </select>
                        </div>

                        {/* <div className="leave_select "> */}
                        <div className={`leave_select ${requesttype == 1 ? 'show' : 'hide'}`} style={{ display: requesttype == 1 ? '' : 'none' }}>
                            <div className="mb-2 row">
                                <div className="col-md-6">
                                    <label className="col-form-label">From Date :</label>
                                    {/* <input type="date" value={fromdate} onChange={(e) => { setFromdate(e.target.value) }} className="form-control" id="from-date" />
                                */}


                                    <DatePicker
                                        placeholderText='YYYY-MM-DD'
                                        value={fromdate}
                                        id="datetime-local"
                                        date={fromdate}
                                        onChange={e => { setFromdate(moment(e).format("YYYY-MM-DD")) }}
                                        className="form-control"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label">To Date :</label>
                                    {/* <input type="date" value={todate} onChange={(e) => { setTodate(e.target.value) }} className="form-control" id="to-date" /> */}


                                    <DatePicker
                                        placeholderText='YYYY-MM-DD'
                                        value={todate}
                                        id="datetime-local"
                                        date={todate}
                                        onChange={e => { setTodate(moment(e).format("YYYY-MM-DD")) }}
                                        className="form-control"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                    />
                                </div>
                            </div>
                            <div className="mb-2">
                                <label className="col-form-label">Leave Type :</label>
                                <select value={leave_type} onChange={(e) => { setLeave_type(e.target.value) }} className="form-select">
                                    <option value=''>Select Type</option>
                                    <option value='1'>Earned Leave</option>
                                    <option value='2'>Casual Leave</option>
                                    <option value='3'>Sick Leave</option>
                                    <option value='4'>Leave Without Pay</option>
                                </select>
                            </div>

                        </div>
                        <div className={`timesheet_select ${requesttype == 2 ? 'show' : 'hide'}`} style={{ display: requesttype == 2 ? '' : 'none' }}>
                            <div className="mb-2">
                                <label className="col-form-label">Regularize Date :</label>

                                {/* <TextField
                                    inputProps={{ min: "2023-05-17" }}
                                    id="datetime-local"
                                    type="date"
                                    value={regularizedate}
                                    onChange={(e) => { handleRegularize(e.target.value) }}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                /> */}
                                <DatePicker
                                    placeholderText='YYYY-MM-DD'
                                    value={regularizedate}
                                    id="datetime-local"
                                    date={regularizedate}
                                    onChange={handleRegularize}
                                    className="form-control"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    maxDate={new Date(Date.now() - (3600 * 1000 * 24))}
                                />
                            </div>


                            <div className="mb-2">
                                <label className="col-form-label">Work From :</label>
                                <select className="form-select" value={workstatus} onChange={(e) => { setWorkstatus(e.target.value) }}>
                                    <option value=''>Select Work From</option>
                                    <option value='1'>Work From office</option>
                                    <option value='2'>Work From Home</option>
                                </select>
                            </div>
                            <div className="mb-2 row">
                                <div className="col-md-6">
                                    <label className="col-form-label">In Time :</label>
                                    <TextField

                                        disabled={regularizedate ? false : true}
                                        className='form-control'
                                        type="time"
                                        value={intime}
                                        onChange={e => { setIntime(e.target.value) }}
                                        // 5 minutes
                                        inputProps={{
                                            step: 300
                                        }}
                                    /> </div>
                                <div className="col-md-6">
                                    <label className="col-form-label">Out Time :{outtime} </label>
                                    <TextField
                                        disabled={regularizedate ? false : true}
                                        className='form-control'
                                        type="time"
                                        value={outtime}
                                        onChange={e => { setOuttime(e.target.value) }}
                                        // 5 minutes
                                        inputProps={{
                                            step: 300
                                        }}
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="mb-3">
                            <label className="col-form-label">Reason</label>
                            <textarea className="form-control" onChange={(e) => { setReason(e.target.value) }} id="reason">{reason}</textarea>
                        </div>
                    </form>
                    <div className="modalfooter">
                        <span style={{ color: err ? err : '' }}>{msg}</span>
                        <button type="button" className="btn_6 float-end ml10" onClick={handleClose} data-bs-dismiss="modal">Cancel</button>
                        <button style={{ display: savebtn ? 'block' : 'none' }} type="button" onClick={handleSubmit} className="btn_5 float-end ">Submit</button>
                    </div>
                </div>
            </Modal>
            <button className="btn_5 float-end" onClick={() => { setTimesheetrequest(!timesheetrequest) }}  >Time Sheet Request</button>
            <Link to='/leave' className="btn_5 float-end mr10">Approve Time Sheet</Link>
            <div className="dash_ttl">
                Attendance
            </div>
            <div className="crumbs">
                <ul id="breadcrumbs" className="breadcrumb">
                    <li>
                        <Link to="/attendance_report" target="_blank" rel="noopener noreferrer" > Pdf </Link>

                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <a> / Attendance</a>
                    </li>
                </ul>
            </div >
            <div className="row">
                <div className="col-md-8">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Statistics {moment().format('YYYY-MM')}-1 To {moment().format('YYYY-MM')}-{moment().daysInMonth()}</div>
                        <div className="pun_cont_wrp">
                            <div className="punch_wrp mb15">
                                <div className="progress_ttl">
                                    Today
                                    <div className="progress_text">
                                        {moment().startOf('day').seconds((get_oermission_data?.attendenace?.In_time?.DiffAB / 1000) + get_oermission_data?.attendenace?.today_att_time?.TodayHRS).format('H:mm:ss')}/9 <span className="pro_hrs">hrs</span>
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    <div className="pro_b progress-cgreen" style={{ width: `${((today_workhr * 100) / 9) + "%"}` }}></div>
                                </div>
                            </div>
                            <div className="punch_wrp mb15">
                                <div className="progress_ttl">
                                    This Week

                                    <div className="progress_text">
                                        {Math.floor(get_oermission_data.attendenace.week_att_time / 60)}
                                        :{get_oermission_data.attendenace.week_att_time % 60}/45 <span className="pro_hrs">hrs</span>
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    <div className="pro_b progress-red" style={{ width: `${((week_workhr * 100) / 45) + "%"}` }}></div>
                                </div>
                            </div>
                            <div className="punch_wrp mb15">
                                <div className="progress_ttl">
                                    This Month
                                    <div className="progress_text">
                                        {/* {moment().startOf('day').seconds(get_oermission_data.attendenace.month_att_time).format('H:mm:ss')} */}
                                        {Math.floor(get_oermission_data.attendenace.month_att_time / 60)}
                                        :{get_oermission_data.attendenace.month_att_time % 60}
                                        /198 <span className="pro_hrs">hrs</span>
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    <div className="pro_b progress-orange" style={{ width: `${((month_workhr * 100) / 198) + "%"}` }}></div>
                                </div>
                            </div>
                            {/* <div className="punch_wrp">
                                <div className="progress_ttl">
                                    Overtime
                                    <div className="progress_text">
                                        5 <span className="pro_hrs">hrs</span>
                                    </div>
                                </div>
                                <div className="progress_bar">
                                    <div className="pro_b progress-yellow" style={{ width: "50%" }}></div>
                                </div>
                            </div> */}
                        </div>

                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Monthly Summary</div>
                        <table className="monthly_table">
                            <thead>
                                <tr>
                                    <th colSpan="2">Attendance : <b>1-{moment().format('MMM-YYYY')} To {moment().daysInMonth()}-{moment().format('MMM-YYYY')}</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ width: "50%" }}>Present</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Absent</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Late In / Early Out</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Leave</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Weekly off </td>
                                    <td>{weekOff}</td>
                                </tr>
                                <tr>
                                    <td>Holiday</td>
                                    <td>{get_oermission_data.attendenace.company_holiday}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div className="row">
                <div className="col-md-8">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Attendance Sheet </div>
                        <ul className="calendar_listing">
                            <li className="calendar_listing_blk"><span className="absent"></span> Absent</li>
                            <li className="calendar_listing_blk"><span className="present"></span> Present</li>
                            <li className="calendar_listing_blk"><span className="weeklyoff"></span> Weekly Off</li>
                            <li className="calendar_listing_blk"><span className="holiday"></span> Holiday</li>
                            <li className="calendar_listing_blk"><span className="leave"></span> Leave</li>
                            <li className="calendar_listing_blk"><span className="outdoor"></span> Outdoor</li>
                            <li className="calendar_listing_blk"><span className="compoff"></span> Compoff</li>
                            <li className="calendar_listing_blk"><span className="halfday"></span> Half Day Present</li>
                            <li className="calendar_listing_blk"><span className="latein"></span> Late In - Early Out</li>
                            <li className="calendar_listing_blk"><span className="workhome"></span> Work From Home </li>
                        </ul>

                        <div className="mb20 float-end d-flex">
                            <select style={{ width: "100px" }} className="form-select mr05" value={year} onChange={e => setYear(e.target.value)}>
                                <option value="">Select Year</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                            </select>
                            <select style={{ width: "100px" }} className="form-select mr05" value={currMonth_in_Number} onChange={e => setCurrMonth_in_Number(e.target.value)}>
                                <option value="">Select Month</option>
                                <option value="1"> Jan </option>
                                <option value="2"> Feb </option>
                                <option value="3"> Mar </option>
                                <option value="4"> Apr </option>
                                <option value="5"> May </option>
                                <option value="6"> Jun </option>
                                <option value="7"> Jul </option>
                                <option value="8"> Aug </option>
                                <option value="9"> Sept </option>
                                <option value="10"> Oct </option>
                                <option value="11"> Nov </option>
                                <option value="12"> Dec </option>
                            </select>

                            {hr_permission.includes('48') && (
                                <select style={{ width: "180px" }} className="form-select" onChange={e => setUser(e.target.value)} value={user} >
                                    <option value=" ">Select User</option>
                                    {
                                        user_filetr?.map((item, ind) => {
                                            return <option value={item.user_id}>{item?.fname}{item?.mname ? ` ${item?.mname}` : ''}{item?.lname ? ` ${item?.lname}` : ''}</option>
                                        })
                                    }
                                </select>
                            )
                            }
                        </div>
                        <h2 style={{ lineHeight: "46px" }} className="mb20"> {month} {year} </h2>

                        <table className="table_style_2">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Attendance View</th>
                                    <th>Start Time</th>
                                    <th>Stop Time</th>
                                    <th>Total Hours</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    // attend_data
                                    Object?.keys(daysinmonth).map(key => (


                                        <>
                                            <tr key={key} className={attend_data[key]?.count > 0 ? 'multiple_count' : ''}>

                                                <td><i className="icon icon-calendar-full mr03"></i>{month} {key < 10 ? '0' + key : key} {daysinmonth[key] ? daysinmonth[key] : ''}</td>
                                                <td>
                                                    {attendance_view(attend_data[key]?.start_time, attend_data[key]?.end_time, office_hilidays[key]?.holiday_name, daysinmonth[key], parseInt(key))}
                                                </td>
                                                <td>
                                                    {attend_data[key]?.start_time ? attend_data[key]?.start_time != '00:00:00' ? <i className="icon icon-clock"></i> : <i className="icon icon-clock"></i> : ''}
                                                    {attend_data[key]?.start_time != '00:00:00' ? attend_data[key]?.start_time ? moment(attend_data[key]?.start_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : '----'}
                                                </td>
                                                <td>
                                                    {attend_data[key]?.end_time ? attend_data[key]?.end_time != '00:00:00' ? <i className="icon icon-clock"></i> : '' : ''}
                                                    {attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? moment(attend_data[key]?.end_time, 'HH:mm').format('hh:mm a').toUpperCase() : '' : attend_data[key].status == 0 ? '--' : ''}
                                                </td>
                                                <td>
                                                    {attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? <i className="icon icon-clock"></i> : '' : ''}
                                                    {attend_data[key]?.end_time != '00:00:00' ? attend_data[key]?.end_time ? calculateHourse(attend_data[key]?.start_time, attend_data[key]?.end_time) + ' HRS' : '' : attend_data[key].status == 0 ? '00:00 HRS' : ''}
                                                </td>
                                                <td>
                                                    {office_hilidays[key]?.day ? attend_data[key]?.end_time ? '' : <div className="table_btn holiday1">{office_hilidays[key]?.holiday_name}</div> : daysinmonth[key] == 'sun' ? <div className="table_btn weeklyoff1">Weekly Off</div> : daysinmonth[key] == 'sat' ? <div className="table_btn weeklyoff1">Weekly Off</div> : attend_data[key]?.start_time ? '' : parseInt(key) > parseInt(current_date_day) ? '' : <div className="table_btn absent1">Absent</div>}
                                                </td>
                                            </tr>
                                            {attend_data[key]?.count > 0 && <InOutComp att_date={attend_data[key]?.att_date} user_id={attend_data[key]?.user_id} count={attend_data[key]?.count} />}
                                        </>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="dash_white_box2 mb20">
                        <div className="dash_white_box_ttl">Approval Flow</div>
                        <p>Here you can see who will approve your attendance related requests</p>
                        <div className="approvalflow_wrp">
                            <img src="assets/images/4.png" alt="" />
                            <div className="approvalflow_ttl">
                                <div>Pallavi Verma</div>
                                <div>Level : <span>Final</span> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* time sheet request start */}

            {/* time sheet request end */}
        </div>
    )
}

export default UserAttendanceCom
